module.exports = __webpack_public_path__ + "media/images/navbar/reseau-9e888269447d8f66d10dfe6167becd6f.png";